import { useMemo, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { SKILLS } from "../data/content";

// A small glowing node-graph ("server room constellation") positioned in the skills segment.
export default function SkillsConstellation({ center = [-5, 3.5, -63] }) {
  const groupRef = useRef();
  const items = useMemo(() => SKILLS.categories.flatMap((c) => c.items), []);

  const nodes = useMemo(() => {
    return items.slice(0, 16).map((_, i) => {
      const phi = Math.acos(1 - (2 * (i + 0.5)) / 16);
      const theta = Math.PI * (1 + Math.sqrt(5)) * i;
      const r = 5;
      return new THREE.Vector3(
        r * Math.sin(phi) * Math.cos(theta),
        r * Math.sin(phi) * Math.sin(theta) * 0.6 + 1,
        r * Math.cos(phi) * 0.8
      );
    });
  }, [items]);

  const lines = useMemo(() => {
    const segs = [];
    nodes.forEach((n, i) => {
      const next = nodes[(i + 1) % nodes.length];
      segs.push(n.x, n.y, n.z, next.x, next.y, next.z);
      const other = nodes[(i + 5) % nodes.length];
      segs.push(n.x, n.y, n.z, other.x, other.y, other.z);
    });
    return new Float32Array(segs);
  }, [nodes]);

  useFrame((_, delta) => {
    if (groupRef.current) groupRef.current.rotation.y += delta * 0.08;
  });

  return (
    <group ref={groupRef} position={center}>
      {nodes.map((n, i) => (
        <mesh key={i} position={n}>
          <sphereGeometry args={[0.16, 12, 12]} />
          <meshBasicMaterial color={i % 2 === 0 ? "#01FFFF" : "#FF007F"} toneMapped={false} />
        </mesh>
      ))}
      <lineSegments>
        <bufferGeometry>
          <bufferAttribute attach="attributes-position" args={[lines, 3]} />
        </bufferGeometry>
        <lineBasicMaterial color="#01FFFF" transparent opacity={0.28} toneMapped={false} />
      </lineSegments>
    </group>
  );
}
